import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { generateUniqueId } from '../../utils/uuid.utils';
import { AnimatedIconType } from './animated-icon.models';

@Component({
  selector: 'app-animated-icon',
  imports: [IconComponent],
  templateUrl: './animated-icon.component.html',
  styleUrl: './animated-icon.component.css',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'inline-flex', 'aria-hidden': 'true' },
})
export class AnimatedIconComponent {
  private readonly _spinnerId = `animated-icon-spinner-${generateUniqueId()}`;

  protected readonly dots = [0, 1, 2];
  protected readonly spinnerRightGradientId = `${this._spinnerId}-right`;
  protected readonly spinnerLeftGradientId = `${this._spinnerId}-left`;

  public readonly type = input.required<AnimatedIconType>();
}
